import { EventAttributesActionLocation } from 'utils/analytics/amplitudeEventConstants';
import { ReservationActions, ReservationType } from 'actions/ReservationActions';

export interface ReservationState {
  isOpen: boolean;
  isMinimized: boolean;
  type?: ReservationType;
  isModifyOpen: boolean;
  actionLocation?: EventAttributesActionLocation;
}

export const initialState: ReservationState = {
  isOpen: false,
  isMinimized: false,
  type: undefined,
  isModifyOpen: false,
  actionLocation: undefined,
};

export default function reducer(
  state = initialState,
  action: ReservationActions
): ReservationState {
  switch (action.type) {
    case 'RESERVATION_OPEN': {
      const { reservationType, actionLocation } = action.payload;

      // defensive check, if it's already open, do not allow a different one to start
      if (state.isOpen) {
        return state;
      }
      return {
        ...state,
        isOpen: true,
        type: reservationType,
        actionLocation: actionLocation,
      };
    }
    case 'RESERVATION_CLOSE': {
      return {
        ...initialState,
      };
    }
    case 'RESERVATION_MODIFY_OPEN': {
      return {
        ...state,
        isModifyOpen: true,
      };
    }
    case 'RESERVATION_MODIFY_CLOSE': {
      return {
        ...state,
        isModifyOpen: false,
      };
    }
    case 'RESERVATION_MINIMIZE': {
      return {
        ...state,
        isMinimized: true,
      };
    }
    case 'RESERVATION_MAXIMIZE': {
      return {
        ...state,
        isMinimized: false,
      };
    }
    default:
      return state;
  }
}
